<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h1>{{ $t('kelaBatch.title') }}</h1>
            </v-col>
            <v-col cols="auto">
                <v-btn
                    color="primary"
                    @click="refresh"
                    :loading="loading"
                >
                    <v-icon left>mdi-refresh</v-icon>
                    {{ $t('kelaBatch.refresh') }}
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <kela-batch-summary @filter-by-status="filterByStatus"></kela-batch-summary>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <kela-batch-table
                    @select-batch="selectBatch"
                ></kela-batch-table>
            </v-col>
        </v-row>

        <v-row v-if="selectedBatch">
            <v-col cols="12" ref="detailPanel">
                <kela-batch-detail-panel
                    :batch="selectedBatch"
                    @close="closeDetails"
                ></kela-batch-detail-panel>
            </v-col>
        </v-row>

        <v-snackbar v-model="errorSnackbar" color="error" timeout="6000">
            {{ error }}
        </v-snackbar>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import KelaBatchTable from "../components/KelaBatch/KelaBatchTable";
import KelaBatchDetailPanel from "../components/KelaBatch/KelaBatchDetailPanel";
import KelaBatchSummary from "../components/KelaBatch/KelaBatchSummary";

export default {
    name: "KelaBatches",
    components: {
        KelaBatchTable,
        KelaBatchDetailPanel,
        KelaBatchSummary
    },
    data() {
        return {
            selectedBatch: null
        };
    },
    computed: {
        ...mapGetters("kelaBatch", ["loading"]),
        tenant() {
            return this.$store.state.user.tenant;
        },
        error() {
            return this.$store.state.kelaBatch.error;
        },
        errorSnackbar: {
            get() {
                return !!this.error;
            },
            set() {
                // close
            }
        }
    },
    watch: {
        tenant() {
            this.searchBatches();
            this.$store.dispatch("kelaBatch/fetchSummary");
        }
    },
    mounted() {
        this.$store.dispatch("kelaBatch/fetchSummary");
        const transportEventId = this.$route.query.TransportEventId;
        if (transportEventId) {
            this.$store.dispatch("kelaBatch/setTransportEventFilter", transportEventId);
        }
    },
    methods: {
        ...mapActions("kelaBatch", ["searchBatches", "setSearchParams"]),
        refresh() {
            this.searchBatches();
        },
        filterByStatus(status) {
            this.setSearchParams(status ? { FeedbackStatus: status } : {});
        },
        selectBatch(batch) {
            this.selectedBatch = batch;
            this.$nextTick(() => {
                const el = this.$refs.detailPanel;
                if (el) {
                    const target = el.$el || el;
                    target.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            });
        },
        closeDetails() {
            this.selectedBatch = null;
        }
    }
};
</script>

<style scoped>
h1 {
    margin-bottom: 0.5rem;
}
</style>
